/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
//import useStateContext from '../hooks/useStateContext'
import { useLocation} from "react-router-dom";
import { BASE_URL, createAPIEndpoint, ENDPOINTS } from '../api/index';
import { Card, Box, CardContent, CardMedia, Typography, Button, Alert, CircularProgress } from '@mui/material';
import { getFormatedTime } from '../helper/index.js';
import { useNavigate } from "react-router-dom";
import { green, blue } from '@mui/material/colors';
import Answer from './Answer.js';


export default function Result() {
   // const { context, setContext } = useStateContext()
    const location = useLocation();
    const navigate = useNavigate();
    const [score, setScore] = useState(0);
    const [qnAnswers, setQnAnswers] = useState([]);
    const totquestions = location.state.options.length;
    const [showAlert, setShowAlert] = useState(false);
    //console.log("Participant", location.state.values);
    //console.log("Candidate ID:", location.state.candidateid)
    //console.log("Result", location.state.options);
    const [submitProgress, setSubmitProgress] = useState(false);
    const [qns, setQns] = useState([]);

    useEffect(() => {
        const ids = location.state.options.map(x => x.qnId);
        //const participant = location.state.values.email;
        const restime = location.state.time;

        createAPIEndpoint(ENDPOINTS.question)
            .fetch()
            .then(res => {
                setQns(res.data);
                //console.log(res.data);
                //startTimer();
            })
            .catch(err => { console.log(err); })

       // return () => { clearInterval(timer) }
    //}, [])

        createAPIEndpoint(ENDPOINTS.getAnswers)
            .post(ids)
            .then(res => {
                const qna = location.state.options
                    .map(x =>  ({
                        ...x,
                        ...(res.data.find(y=>y.qnId===x.qnId))
                    }))
                //console.log(res.data);
                //console.log("Candidate:", participant);
                //console.log("Time:", restime);
                //console.log("Answers",qna);
                setQnAnswers(qna);
                calculateScore(qna);
            })
            .catch(err=>console.log(err))

    }, [])

    const calculateScore = qna => {
        let tempScore = qna.reduce((acc, curr) => {
            return curr.answer === curr.selected ? acc + 1 : acc;
        }, 0)
        setScore(tempScore)
    }

    const restart = () => {
        navigate("/login")
    }

    const submitScore = () => {
        setSubmitProgress(true);
        createAPIEndpoint(ENDPOINTS.participant)
            .put(location.state.candidateid, {
                participantId: location.state.candidateid,
                score: score,
                timeTaken:location.state.time
            })
            .then(res => { //console.log(res)
                setSubmitProgress(false);
                setShowAlert(true)
                setTimeout(() => {
                    setShowAlert(false)
                },4000)            })
            .catch(err => {
                console.log(err);
                setSubmitProgress(false);
            })
    }
    

    return (
<>
        <Card sx={{ mt:1, mb:1, display:'flex', width:'100%', maxWidth:640, mx:'auto'}}>
            <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow:1 }}>
                    <CardContent sx={{ flex: '1 0 auto', textAlign: 'center' }}>
                        {score * 100 / qns.length > 65 ? <Typography variant="h4">Congratulations</Typography>
                            : <Typography variant="h4">Sorry! Try again.</Typography>}
                    <Typography variant="h6" color={green[200] }>{location.state.values.email }</Typography>
                    <Typography variant="h6">
                    Your Score
                    </Typography>
                    <Typography variant="h5" sx={{fontWeight:600} }>
                        <Typography variant="span" color={green[500] }>
                            {score}
                            </Typography>/{qns.length}
                    </Typography>
                    <Typography variant="h6" color={blue[400] }>
                        Took {getFormatedTime(location.state.time) + ' mins'}
                    </Typography>
                    <Button variant="container"
                        sx={{ mx: 1 }}
                        size="small"
                        onClick={submitScore}>
                        Submit
                        </Button>
                        <Box sx={{
                            display: 'flex',
                            visibility: submitProgress ? 'visible' : 'hidden',
                            height: submitProgress ? 'auto' : 0
                        }}>
                            <CircularProgress />
                        </Box>
                    <Button variant="container"
                        sx={{ mx: 1 }}
                        size="small"
                        onClick={restart}
                    >
                        Re-try
                    </Button>
                    <Alert
                        severity="success"
                        variant="string"
                        sx={{
                            width: '60%',
                            m: 'auto',
                            visibility: showAlert ? 'visible' : 'hidden'
                        } }
                    >
                    Score Updated
                    </Alert>
                </CardContent>
                </Box>
            <CardMedia
                component="img"
                sx={{ width: '35%' }}
                    image={score * 100 / qns.length > 85 ? "./result.png" : BASE_URL + "Images/fail.png"}
                alt="Can you read Qur'an?"
            />
            </Card>
            <Answer qnAnswers={qnAnswers} />

        </>
    )
}